const apiBase = () => (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) || '';

const authHeaders = (userId: string, orgId?: string): Record<string, string> => ({
  'Content-Type': 'application/json',
  'x-api-key': 'revisr',
  'x-user-id': userId,
  ...(orgId ? { 'x-org-id': orgId } : {}),
});

export type DocumentRegisterSignup = {
  id: string;
  email: string;
  user_id: string | null;
  org_id: string | null;
  full_name: string | null;
  account_email: string | null;
  phone: string | null;
  job_title: string | null;
  department: string | null;
  company: string | null;
  org_name: string | null;
  org_role: string | null;
  source: string;
  created_at: string;
};

export type SignupStats = {
  totalCount: number;
  uniqueOrgs: number;
  last7Days: number;
};

/** Returns 'ok' | 'duplicate' | 'error'. Never throws — the page handles all three states. */
export const submitDocumentRegisterSignup = async (
  email: string,
  userId: string,
  orgId?: string,
): Promise<'ok' | 'duplicate' | 'error'> => {
  try {
    const res = await fetch(`${apiBase()}/api/revisr/document-register-signups`, {
      method: 'POST',
      headers: authHeaders(userId, orgId),
      body: JSON.stringify({ email }),
    });
    if (res.status === 409) return 'duplicate';
    return res.ok ? 'ok' : 'error';
  } catch {
    return 'error';
  }
};

export const fetchAdminSignups = async (
  params: { orgId?: string; limit?: number; offset?: number },
  userId: string,
  orgId?: string,
): Promise<{ items: DocumentRegisterSignup[]; stats: SignupStats }> => {
  const q = new URLSearchParams();
  if (params.orgId) q.set('orgId', params.orgId);
  if (params.limit !== undefined) q.set('limit', String(params.limit));
  if (params.offset !== undefined) q.set('offset', String(params.offset));
  const res = await fetch(
    `${apiBase()}/api/revisr/document-register-signups/admin?${q.toString()}`,
    { headers: authHeaders(userId, orgId) },
  );
  if (!res.ok) throw new Error(`Failed to load signups: ${res.status}`);
  return res.json();
};
